/*//////////////////////*/
/* Exports
/*//////////////////////*/
export const getHistoryReducer = (state) => state.history;
